module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Saturation-63202f1b631bb9c07ae6a960bb5b3e44.svg";